import { NgModule, APP_INITIALIZER }           from '@angular/core';
import { CommonModule }       from '@angular/common';
import { FormsModule }        from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { DashboardComponent }   from './dashboard.component';
import { LastProjectsComponent } from './last-projects/last-projects.component';
import { LastProjectsFiComponent } from './last-projects-fi/last-projects-fi.component';
import { LastProposalsComponent } from './last-proposals/last-proposals.component';
import { LastProposalsContractadesComponent } from './last-proposals-contractades/last-proposals-contractades.component';
import { LastPreProposalsEncontractacioComponent } from './last-preproposals-contractacio/last-preproposals-contractacio.component';
import { LastPreproposalsComponent } from './last-preproposals/last-preproposals.component';
import { LastIncidencies0Component } from './last-incidencia-0/last-incidencia-0.component';
import { LastIncidencies1Component } from './last-incidencia-1/last-incidencia-1.component';
import { LastIncidencies2Component } from './last-incidencia-2/last-incidencia-2.component';
import { LastIncidencies3Component } from './last-incidencia-3/last-incidencia-3.component';
import { LastIncidencies4Component } from './last-incidencia-4/last-incidencia-4.component';
import { LastIncidencies5Component } from './last-incidencia-5/last-incidencia-5.component';
import { LastIncidencies6Component } from './last-incidencia-6/last-incidencia-6.component';
import { ListResumeComponent } from './list.resume/list.resume.component';
import { AngularMaterialModule } from '../angular-material.module';

export function appInitializerFactory(translate: TranslateService, languageService: LanguageService) {
  return () => languageService.initAndWait();
}

@NgModule({
  imports:      [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    TranslateModule
  ],
  providers:    [ 
    LastProjectsComponent,
    LastProposalsComponent,
    LastProposalsContractadesComponent,
    LastPreProposalsEncontractacioComponent,
    LastPreproposalsComponent,
    LastProjectsFiComponent,
    LastIncidencies0Component,
    LastIncidencies1Component,
    LastIncidencies2Component,
    LastIncidencies3Component,
    LastIncidencies4Component,
    LastIncidencies5Component,
    LastIncidencies6Component,
    ListResumeComponent,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService, LanguageService],
      multi: true
    }
  ],
  declarations: [
    DashboardComponent,
    LastProjectsComponent,
    LastProposalsComponent,
    LastPreProposalsEncontractacioComponent,
    LastPreproposalsComponent,
    LastProposalsContractadesComponent,
    LastProjectsFiComponent,
    LastIncidencies0Component,
    LastIncidencies1Component,
    LastIncidencies2Component,
    LastIncidencies3Component,
    LastIncidencies4Component,
    LastIncidencies5Component,
    LastIncidencies6Component,
    ListResumeComponent
  ],
  exports:      [ DashboardComponent ]
})
export class DashboardModule { }
